export default __webpack_public_path__ + "static/media/product.622b8d4f.svg";